'use client' // Error boundaries must be Client Components

import { useEffect } from 'react'
import { logError } from '@/app/actions/log'
import { trackEvent } from '@/firebase'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
    logError(
      `${window.location.href} ${error?.message || error || 'Unknown error'}`
    )

    trackEvent('page-error', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_referrer: document.referrer,
      page_host: window.location.host,
      page_hostname: window.location.hostname,
      page_protocol: window.location.protocol,
    })
  }, [error])

  return (
    <div className="page-error text-center p-3">
      <h2 className="text-xl py-4">Something went wrong!</h2>
      <button
        className="bg-orange-600 px-4 py-2 text-white "
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  )
}
